import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

const AboutSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id='about' className="py-20 lg:py-28 bg-white">
      <div className="max-w-[86rem] mx-auto px-6 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Left Column - Heading */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
            transition={{ duration: 0.8 }}
            className="lg:sticky lg:top-24"
          >
            {/* Eyebrow with Icon */}
            <div className="flex items-center gap-3 mb-6">
              <div className="w-6 h-6 rounded-full border-2 border-gray-900 flex items-center justify-center">
                <div className="w-2.5 h-2.5 rounded-full bg-gray-900"></div>
              </div>
              <span className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
                About Us
              </span>
            </div>

            {/* Main Heading */}
            <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 leading-tight">
              Building Tailored <span className="text-[#F7941D]">Solutions</span> That Turn Business Challenges Into  <span className="text-[#F7941D]">Opportunities</span>
            </h2>
          </motion.div>

          {/* Right Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-6"
          >
            {/* Paragraph 1 */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-base lg:text-lg text-gray-700 leading-relaxed"
            >
              Quick SMS Ghana Limited is a licensed Value-Added Service (VAS) provider established in August 2016. The firm has a business-friendly flow which provides mobile solutions on SMS, USSD, E-Voting, Bulk E-Mail, Voice Call, and Premium Services to Business-to-Business and Business-to-Consumer.
            </motion.p>

            {/* Paragraph 2 */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-base lg:text-lg text-gray-700 leading-relaxed"
            >
              At Quick SMS Ghana, we have provided solutions that are specifically tailored to each and every client's specific needs. We ensure that we understand the business as if it were our own. We identify the challenges and create strategies that turn every problem into an opportunity.
            </motion.p>

            {/* Paragraph 3 */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="text-base lg:text-lg text-gray-700 leading-relaxed"
            >
              We have all witnessed the time swing towards digitization and everything we are doing now in life lends itself to be digitized. This has presented us with the opportunity to build and digitize new experiences to progress the traditional ways of entertaining and having fun on the go to ensure continuity.
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;